import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, of, switchMap } from 'rxjs';
import * as correctiveActionActions from '../actions/corrective-action.actions';
import { CorrectiveActionService } from '../../services/corrective-action.service';

@Injectable()
export class CorrectiveActionEffects {
  constructor(
    private actions$: Actions,
    private correctiveActionService: CorrectiveActionService
  ) {}

  // Load corrective actions
  loadCorrectiveAction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(correctiveActionActions.loadCorrectiveAction),
      mergeMap(({ ruleUid }) => {
        return this.correctiveActionService.GetByRuleUid(ruleUid).pipe(
          map((correctiveAction) => {
            return correctiveActionActions.loadCorrectiveActionSuccess({
              correctiveAction,
            });
          }),
          catchError((error) => {
            return of(
              correctiveActionActions.loadCorrectiveActionFailure({ error })
            );
          })
        );
      })
    )
  );

  // Delete multiple corrective actions
  deleteMultipleCorrectiveActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(correctiveActionActions.deleteMultipleCorrectiveActions),
      mergeMap(({ uids }) => {
        return this.correctiveActionService
          .DeleteMultipleCorrectiveActions(uids)
          .pipe(
            map(() =>
              correctiveActionActions.deleteMultipleCorrectiveActionsSuccess({
                uids,
              })
            ),
            catchError((error) =>
              of(
                correctiveActionActions.deleteMultipleCorrectiveActionsFailure({
                  error,
                })
              )
            )
          );
      })
    )
  );

  // Create multiple corrective actions
  createMultipleCorrectiveActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(correctiveActionActions.createMultipleCorrectiveActions),
      mergeMap(({ requests }) => {
        return this.correctiveActionService
          .CreateMultipleCorrectiveActions(requests)
          .pipe(
            map((correctiveActions) =>
              correctiveActionActions.createMultipleCorrectiveActionsSuccess({
                correctiveActions,
              })
            ),
            catchError((error) =>
              of(
                correctiveActionActions.createMultipleCorrectiveActionsFailure({
                  error,
                })
              )
            )
          );
      })
    )
  );

  // Update multiple corrective actions
  updateMultipleCorrectiveActions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(correctiveActionActions.updateMultipleCorrectiveActions),
      mergeMap(({ requests }) => {
        return this.correctiveActionService
          .UpdateMultipleCorrectiveActions(requests)
          .pipe(
            map((correctiveActions) =>
              correctiveActionActions.updateMultipleCorrectiveActionsSuccess({
                correctiveActions,
              })
            ),
            catchError((error) =>
              of(
                correctiveActionActions.updateMultipleCorrectiveActionsFailure({
                  error,
                })
              )
            )
          );
      })
    )
  );
}
